<template>
  <div class="box">
    <div
      v-for="(item, index) in listArr"
      :key="index"
      @click="Select != '1' ? handleItemCheck(item) : ''"
      :class="item.createBy == 1 ? 'module-Con-selected' : 'module-Con'"
    >
      <div class="BasicInformation">
        <p><span>车牌：</span>{{ item.carNum }}</p>
      </div>
      <div class="BasicInformation">
        <p><span>车辆类型：</span>{{ item.carTypeName }}</p>
        <p
          :title="`投保种类：${item.safeTypeName || ''}`"
          style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis"
        >
          <span>投保种类：</span>{{ item.safeTypeName }}
        </p>
        <p
          :title="`意向投保：${item.safeCompanyFlagName || ''}`"
          style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis"
        >
          <span>意向投保：</span>{{ item.safeCompanyFlagName }}
        </p>
      </div>
      <div class="BasicInformation">
        <p><span>姓名：</span>{{ item.username }}</p>
        <p><span>手机号：</span>{{ item.userPhone }}</p>
        <p><span>车辆性质：</span>{{ item.carOwnerTypeName }}</p>
      </div>
      <div class="Locations">
        <p class="address">{{ item.areaName }}</p>
        <p v-if="item.firstFlag == 0">
          车险到期日期：{{ formatDateOnly(item.expirationTime) }}
        </p>
        <p v-if="item.firstFlag == 1">
          车险预计购买日期：{{ formatDateOnly(item.buyTime) }}
        </p>
      </div>
      <div class="Remaining" v-if="Select == '1'">
        <p class="firm-clickable" @click="handelPurchase(item)">购买</p>
      </div>
      <div class="Remaining" v-if="Select == '2' || Select == '4'">
        <p class="firm-clickable" @click.stop="handelPurchase(item)">转发</p>
      </div>
    </div>
    <Purchase
      :dialogPurchase="dialogPurchase"
      :Select="Select"
      :PropNumber="PropNumber"
      @handleClosePurchase="dialogPurchase = false"
      @handlePurchase="handlePurchase"
    ></Purchase>
    <InformationCard
      :dialogInformationCard="dialogInformationCard"
      @handleClosePurchase="dialogInformationCard = false"
      @handlePurchaseCompleted="handlePurchaseCompleted"
    ></InformationCard>
  </div>
</template>

<script>
import {
  getPropCount, //获取道具剩余可用数量
  buyCarSafeInfoByInfoCard, //使用信息卡购买车险商机
  carSafeInfoForward, //转发
} from "../../../../../assets/api/firm/Opportunity";
import Purchase from "./Purchase"; //购买弹窗
import InformationCard from "./InformationCard.vue"; //购买信息卡弹窗
export default {
  props: {
    listArr: {
      type: Array,
      default: () => [],
    },
    Select: {
      type: [String, Number],
      default: "1",
    }, // 页面区分 1智能匹配  2分配商机  3转发  4购买
    DownloadNum: {},
  },
  data() {
    return {
      dialogPurchase: false, //购买弹窗开启关闭
      PropNumber: 0, //剩余道具可用数量
      itemData: {}, //被操作项
      selectedData: [], // 跨分页存储选中的ID数组（核心：只存ID）
      dialogInformationCard: false, //信息卡购买
    };
  },
  components: {
    Purchase, // 购买弹窗
    InformationCard,
  },

  watch: {
    DownloadNum: {
      immediate: false, // 初始化时也执行
      handler(newVal) {
        console.log("切换列表清空选择");
        this.selectedData = [];
        for (var i in this.listArr) {
          this.listArr[i].createBy = "";
        }
      },
    },
    Select: {
      immediate: true, // 初始化时也执行
      handler(newVal) {
        console.log("切换列表清空选择");
        this.selectedData = [];
      },
    },
    // 监听列表数据变化（翻页时），恢复当前页数据的勾选状态
    listArr: {
      immediate: true, // 初始化时也执行
      handler(newVal) {
        if (newVal && newVal.length) {
          this.resetCurrentPageCheckStatus();
        }
      },
    },
  },
  created() {
    // 信息卡剩余数量
    this.getPropCount();
  },
  methods: {
    formatDateOnly(val) {
      if (!val) return "";
      const text = String(val);
      if (text.includes(" ")) return text.split(" ")[0];
      if (text.includes("T")) return text.split("T")[0];
      return text;
    },
    //购买信息卡成功
    handlePurchaseCompleted() {
      this.getPropCount();
      this.dialogInformationCard = false;
    },
    // 单个勾选框变化
    handleItemCheck(item) {
      // 先找到当前ID在选中数组中的索引
      const idIndex = this.selectedData.findIndex((id) => id === item.id);
      if (idIndex > -1) {
        // 已选中 → 取消选中

        item.createBy = "";
        this.selectedData.splice(idIndex, 1); // 移除ID

        this.$emit("handelCheck", this.selectedData);
      } else {
        // 未选中 → 选中
        item.createBy = 1;
        this.selectedData.push(item.id); // 规范添加ID
        this.$emit("handelCheck", this.selectedData);
      }
    },

    // 翻页后恢复当前页数据的勾选状态（核心：跨分页保留勾选）
    resetCurrentPageCheckStatus() {
      this.listArr.forEach((item) => {
        // 判断当前项ID是否在选中列表中，恢复对应的状态值
        item.createBy = this.selectedData.includes(item.id) ? 1 : "";
      });
    },

    //获取道具剩余可用数量
    getPropCount() {
      getPropCount({ data: 3 })
        .then((res) => {
          if (res && res.data) {
            this.PropNumber = res.data.propCount;
          }
        })
        .catch((err) => {
          console.error("获取道具数量失败：", err);
        });
    },

    // 购买弹窗 确认
    handlePurchase(input, code) {
      // 统一构造参数
      const requestData = {
        data: {
          infoIdList: [this.itemData.id], // 直接传入数组
          companyId: code,
          allocationType: this.Select == "2" ? "0" : "1",
        },
      };

      // 根据Select判断操作类型
      if (this.Select == 1) {
        // 购买
        buyCarSafeInfoByInfoCard(requestData)
          .then((res) => {
            if (res.code == 0) {
              this.$tool.PromptBox("success", "操作成功");
              this.dialogPurchase = false;
              this.$emit("handlePurchaseForward");
              this.getPropCount();
            }
          })
          .catch((err) => {
            console.error("购买失败：", err);
          });
      } else {
        // 转发
        carSafeInfoForward(requestData)
          .then((res) => {
            if (res.code == 0) {
              this.$tool.PromptBox("success", "操作成功");
              this.dialogPurchase = false;
              this.$emit("handlePurchaseForward");
            }
          })
          .catch((err) => {
            console.error("转发失败：", err);
          });
      }
    },

    // 点击购买/转发按钮
    handelPurchase(item) {
      if (!this.$checkAction()) return
      this.itemData = item;
      // 购买时校验道具数量
      if (this.Select == "1" && this.PropNumber <= 0) {
        console.log("购买信息卡");
         this.$tool.PromptBox("warning", "已无可用信息卡，请购买信息卡");
        // this.dialogInformationCard = true;

        // 跳转到道具管理页面购买
        
         this.$router.push("/Firm/propHire");
      } else {
        // 打开弹窗
        this.dialogPurchase = true;
      }
    },
  },
};
</script>

<style scoped lang="less">
// 选中态样式：蓝色边框
.box {
  width: 100%;
  height: 100%;
  font-family: PingFangSC-Medium;
  font-weight: 400;

  .module-Con-selected {
    height: 80px;
    padding: 20px;
    background: #ffffff;
    border-color: #409eff ; // 与现有按钮同色系的蓝色
    box-shadow: 0px 0px 8px 0px rgba(97, 144, 232, 0.6); // 可选：增加选中态阴影，更醒目
    border-radius: 15px;
    display: flex;
    margin-bottom: 20px;
  }

  .module-Con {
    height: 80px;
    padding: 20px;
    background: #ffffff;
    box-shadow: 0px 0px 5px 0px rgba(125, 125, 125, 0.5);
    border-radius: 15px;
    display: flex;
    margin-bottom: 20px;
  }

  .BasicInformation {
    width: 150px;
    margin-right: 70px;
    display: flex;
    flex-direction: column;

    p {
      height: 17px;
      line-height: 17px;
      font-size: 12px;
      color: #333333;
      margin: auto 0;

      span {
        color: #666666;
      }
    }
  }

  .Locations {
    min-width: 180px;
    display: flex;
    flex-direction: column;
    font-size: 12px;
    color: #999999;

    .address {
      width: 100px;
      height: 30px;
      line-height: 30px;
      background: rgba(97, 144, 232, 0.2);
      border-radius: 5px;
      font-size: 12px;
      color: #409eff ;
      text-align: center;
    }

    p {
      margin: auto;
    }
  }

  .Remaining {
    flex: 1;
    display: flex;
    justify-content: flex-end;

    p {
      width: 100px;
      height: 35px;
      line-height: 35px;
      background: #409eff ;
      border-radius: 5px;
      font-size: 14px;
      color: #ffffff;
      text-align: center;
      margin: auto 0;
      cursor: pointer;
    }
  }
}
</style>
